import type { NavPalette } from "@/components/design-switcher/nav-palette";

export const WATERCOLOR_FILTER_ID = "v9-watercolor";
export const WATERCOLOR_HEAVY_ID = "v9-watercolor-heavy";
export const PAPER_TEXTURE_ID = "v9-paper-texture";
export const SPLATTER_FILTER_ID = "v9-splatter";

export const c = {
  flamenco: "#F05260",
  flamencoSoft: "#F47781",
  flamencoPale: "#FBDDE1",
  flamencoWash: "#FEF0F2",
  skyfall: "#84D5F7",
  skyfallSoft: "#A7E2FB",
  skyfallPale: "#D4F0FD",
  skyfallWash: "#EDF9FE",
  mintleaf: "#4EB969",
  mintleafSoft: "#7ED494",
  mintleafPale: "#C6EDCF",
  mintleafWash: "#EDFAF0",
  plumwood: "#842885",
  plumwoodSoft: "#B55FB6",
  plumwoodPale: "#E4BDE5",
  plumwoodWash: "#F6E8F6",
  cream: "#FFFDF8",
  warmWhite: "#FFF9F0",
  inkDark: "#3B2844",
  inkMedium: "#6B5478",
  inkLight: "#9A87A6",
};

export const nav: NavPalette = {
  surface: "rgba(255, 253, 248, 0.88)",
  surfaceHover: "rgba(255, 249, 240, 0.94)",
  border: "rgba(59, 40, 68, 0.22)",
  text: "#3B2844",
  textMuted: "rgba(107, 84, 120, 0.8)",
  activeBg: "rgba(228, 189, 229, 0.6)",
  activeText: "#842885",
};
